// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1iACw","title":"Info_title__3HxM8","links":"Info_links__2V6y-","link":"Info_link__3R4QO","logo":"Info_logo__3Scuh"};